import React from "react";
import * as S from "sanctuary";
import {
  BankGenericSmallIcon,
  WireSmallIcon,
  CashSmallIcon,
  Cluster,
  Text,
  Box,
  CardType,
} from "@thecb/components";
import { toTitleCase, PAYMENT_TYPES } from "@/util/common";

const PaymentDisplay = ({ icon, text }) => (
  <Cluster justify="flex-start" align="center">
    <Box padding="0 0.5rem 0 0">{icon}</Box>
    <Text variant="pS">{text}</Text>
  </Cluster>
);

const PaymentTypeWithIcon = ({ creditCard, bankAccount, paymentType }) => {
  if (S.isJust(creditCard)) {
    const cardType = S.fromMaybe("")(creditCard.value.type);
    const lastFour = S.fromMaybe("")(creditCard.value.lastFour);

    return <PaymentDisplay icon={<CardType type={cardType} />} text={lastFour} />;
  }

  if (S.isJust(bankAccount)) {
    const lastFour = S.fromMaybe("")(bankAccount.value.lastFour);

    return <PaymentDisplay icon={<BankGenericSmallIcon />} text={lastFour} />;
  }

  if (paymentType === PAYMENT_TYPES.WIRE_PAYMENT) {
    return <PaymentDisplay icon={<WireSmallIcon />} text="Wire transfer" />;
  }

  if (paymentType === PAYMENT_TYPES.CASH) {
    return <PaymentDisplay icon={<CashSmallIcon />} text="Cash" />;
  }

  // Fallback for other payment types
  return <Text variant="pS">{toTitleCase(paymentType)}</Text>;
};

export default PaymentTypeWithIcon;
